export const monthOptions = [
    { id: 1, label: "January" },
    { id: 2, label: "February" },
    { id: 3, label: "March" },
    { id: 4, label: "April" },
    { id: 5, label: "May" },
    { id: 6, label: "June" },
    { id: 7, label: "July" },
    { id: 8, label: "August" },
    { id: 9, label: "September" },
    { id: 10, label: "October" },
    { id: 11, label: "November" },
    { id: 12, label: "December" },
  ];

const currentYear = new Date().getFullYear();
export const yearOptions = Array.from({ length: 50 }, (_, i) => ({
    id: currentYear - i,
    label: `${currentYear - i}`,
}));

export const calculateYearsOfPractice = (year: number, month: number) => {
  if (!year || !month) return "0 years";

  const startDate = new Date(year, month - 1); 
  const currentDate = new Date();

    const diffInMonths = 
        (currentDate.getFullYear() - startDate.getFullYear()) * 12 + 
        (currentDate.getMonth() - startDate.getMonth());

    if (diffInMonths <= 0) return "0 years";

    const years = diffInMonths / 12;

    const roundedYears = Math.round(years * 2) / 2;

    return `${roundedYears} ${roundedYears === 1 ? "year" : "years"}`;
};